import {EState} from '@app/state/reducers';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FeatureFlagState} from '../models/feature-flag-state.model';

export const selectFeatureFlagState = createFeatureSelector<FeatureFlagState>(EState.FeatureFlags);
export const selectAllFeatureFlags = createSelector(selectFeatureFlagState, state => state.flags);
